<template>
  <div id="app">
    <router-view />
  </div>
  
</template>

<script>
export default {
  name: 'App',
  mounted() {
    // 设置根字体大小用于rem适配
    this.setRootFontSize();
    window.addEventListener('resize', this.setRootFontSize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setRootFontSize);
  },
  methods: {
    setRootFontSize() {
      const width = document.documentElement.clientWidth || document.body.clientWidth;
      const fontSize = width / 10; // 基于375px设计稿，1rem = 37.5px
      document.documentElement.style.fontSize = Math.min(fontSize, 50) + 'px';
    }
  }
}
</script>

<style>
#app {
  height: 100vh;
  overflow-x: hidden;
  background: #F5F7FF;
}
</style>